import dayjs from 'dayjs';

import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/pt-br';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.locale('pt-br');

export const formatDate = (
    date?: string | Date | dayjs.Dayjs,
    format = 'YYYY-MM-DD',
) => {
    if (!date) return undefined;
    return dayjs(date).format(format);
};

export default dayjs;
